import { createFileRoute } from "@tanstack/react-router";
import { requireAuth } from "@/common/routes/requireAuth";
import { useOrganization } from "@/pages/organizations/detail";
import OverviewPage from "@/pages/organizations/detail/overview";

export const Route = createFileRoute("/app/organizations/$organizationId/overview/$tab")({
  beforeLoad: ({ context }) => {
    requireAuth(context);
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { tab } = Route.useParams();
  const activeTab = tab || null;
  const { organization, userCanViewAssessments, userCanEditAssessments } = useOrganization();

  return (
    <OverviewPage
      activeTab={activeTab}
      organization={organization}
      userCanEditAssessments={userCanEditAssessments}
      userCanViewAssessments={userCanViewAssessments}
    />
  );
}
